export default "__VITE_ASSET__B6w1QKlJ__"